/** Compatibility export; the business domain owns this implementation. */
export { EnumSearchType, MATCH_ALL_SEARCH_MAX_TERMS } from '@domains/research/shared';
